import React, { useRef, useEffect, useState } from "react";
import { Tag } from "antd";

const PiScoreTag = ({ value }) => {
    const prevValueRef = useRef(value);
    const [color, setColor] = useState("bg-darkMode-layer3");

    useEffect(() => {
        const prev = prevValueRef.current ?? 0;
        const current = value ?? 0;
        if (current > prev) setColor("text-green-500");
        else if (current < prev) setColor("text-red-500");
        else setColor("text-white");

        prevValueRef.current = current;
    }, [value]);

    return (
        <Tag className={`rounded-full ${color} bg-darkMode-layer3 text-sm`}>
            {(value ?? 0).toFixed(2)}
        </Tag>
    );
};

export default PiScoreTag